@if (report) {
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>Field Usage</h2>
    <mat-icon (click)="closeSideBar()" class="sidebar-close-button"
      >close</mat-icon
    >
  </div>
  <p><b>Type: </b>{{ report.associatedType }} {{ uiName }}</p>
  <div fxLayout="row" fxLayoutGap="10">
    <div class="usage-count">
      <p>{{ report.associatedCount }}</p>
      <p>{{ report.associatedUageTypeName }} with values</p>
    </div>
    <div class="usage-count">
      <p>{{ report.associatedForms.length }}</p>
      <p>On Forms, Surveys, or Evaluations</p>
    </div>
  </div>
  @if (report.associatedForms.length > 0) {
    <p class="mb-0">
      <b>Used on the following:</b>
    </p>
  }
  @for (form of forms$ | async; track form) {
    <div fxLayout="row" fxLayoutGap="10">
      <div fxLayout="row" fxFlex="50">
        <p class="form-title" (click)="navigateTo(form)">{{ form.title }}</p>
      </div>
      <div fxLayout="row" fxFlex="50" fxLayoutAlign="start">
        <p>
          {{ form.formTypeName }} {{ form.isClosed ? '(Closed)' : '(Open)' }}
        </p>
      </div>
    </div>
  }
}
